import { createContext, useState } from "react";

type NavBarContextType = {
    notDisplay: boolean;
    updateNavBarParams: (v: any) => void;
};

export const NavBarContext = createContext<NavBarContextType>({
    notDisplay: false,
    updateNavBarParams: (value: any) => null,
});

export const NavBarContextProvider = (props: any) => {
    const [navBarParams, setNavBarParams] = useState({ notDisplay: false });

    const updateNavBarParams = (value: any) => {
        setNavBarParams(value);
    };

    return (
        <NavBarContext.Provider
            value={{
                ...navBarParams,
                updateNavBarParams,
            }}
        >
            {props.children}
        </NavBarContext.Provider>
    );
};
